$(document).ready(function () {
    // Before after slider
    $(".ba-slick-slider").slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: `<button type="button" class="slick-prev">
        <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.8475 16.59L1.3275 10.07C0.5575 9.3 0.5575 8.04 1.3275 7.27L7.8475 0.75" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`,
        nextArrow: `<button type="button" class="slick-next">
        <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 16.59L7.27 10.07C8.04 9.3 8.04 8.04 7.27 7.27L0.75 0.75" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Initialize Slick
    $(".testimonial-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: false,
        prevArrow: `
    <button type="button" class="slick-prev">
      <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.8475 16.59L1.3275 10.07C0.5575 9.3 0.5575 8.04 1.3275 7.27L7.8475 0.75"
          stroke="white" stroke-width="1.5" stroke-miterlimit="10"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
        nextArrow: `
    <button type="button" class="slick-next">
      <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 16.59L7.27 10.07C8.04 9.3 8.04 8.04 7.27 7.27L0.75 0.75"
          stroke="white" stroke-width="1.5" stroke-miterlimit="10"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
        responsive: [
            { breakpoint: 1025, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 500, settings: { slidesToShow: 1 } },
        ],
    });

    // Testimonial Read More And Read Less funcanality
    $(".testimonial-text-wrapper").each(function () {
        var fullText = $(this).find(".testimonial-text").data("full-text").trim();
        var shortText = fullText.substring(0, 150) + "...";

        var textBox = $(this).find(".testimonial-text");
        var readMoreBtn = $(this).find(".read-more-btn");
        var readLessBtn = $(this).find(".read-less-btn");

        if (fullText.length <= 150) {
            textBox.text(fullText);
            readMoreBtn.hide();
            readLessBtn.hide();
            return; 
        }

        textBox.text(shortText);
        readLessBtn.hide();

        // Read More
        readMoreBtn.on("click", function () {
            textBox.text(fullText);
            readMoreBtn.hide();
            readLessBtn.show();
        });

        // Read Less
        readLessBtn.on("click", function () {
            textBox.text(shortText);
            readLessBtn.hide();
            readMoreBtn.show();
        });
    });

    // services footer
    function initFeatureSlider() {
        if ($(window).width() <= 1025) {
            if (!$(".services-blocks").hasClass("slick-initialized")) {
                $(".services-blocks").slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                adaptiveHeight: true,
                            },
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                adaptiveHeight: true,
                            },
                        },
                    ],
                });
            }
        } else {
            if ($(".services-blocks").hasClass("slick-initialized")) {
                $(".services-blocks").slick("unslick");
            }
        }
    }
    initFeatureSlider();
    $(window).on("resize", initFeatureSlider);

    //Newsletter send ZOHO CRM
   $(document).on('click', '.newsletter-form__button', function (e) {
        e.preventDefault();
        const $button = $(this);
        const $wrapper = $button.closest('.newsletter-form__field-wrapper');
        const emailValue = $wrapper.find('input[name="contact[email]"]').val();
        const fd = new FormData();
        fd.append('contact[email]', emailValue);

        $button.prop('disabled', true).css('opacity', '0.5');
        $.ajax({
            url: 'https://ourportfolios.co/shopify-webhook/nextveda/newsletter-webhook.php',
            method: 'POST',
            data: fd,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (res) {
                console.log('Success:', res);
            },
            error: function (xhr) {
                console.error('Error:', xhr.responseText);
            },
            complete: function() {
                $button.prop('disabled', false).css('opacity', '1');
            }
        });
    });

    // Optional: Still allows 'Enter' key to trigger the click
    $(document).on('keypress', '.newsletter-form__field-wrapper input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $(this).closest('.newsletter-form__field-wrapper').find('.newsletter-form__button').trigger('click');
        }
    });

    // Contact Form lead Form ZOHO CRM
	$(document).on('submit', '.contact-form', function (e) {
        e.preventDefault(); 
        const form = $(this);
        const $submitBtn = form.find('input[type="submit"]');
        const formData = new FormData(this); 

        $submitBtn.prop('disabled', true).val('Sending...');

        for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`);
        }

        $.ajax({
            url: 'https://ourportfolios.co/shopify-webhook/nextveda/lead-webhook.php',
            type: 'POST',
            data: formData,
            processData: false, 
            contentType: false, 
            success: function (res) {
                console.log("✅ Sent to webhook", res);
                    form[0].reset(); 
                form.before(`
                    <p class="t4s-form-message t4s-form-message--success" tabindex="-1" style="color: green; margin-bottom: 20px;">
                        Thanks for contacting us. We'll get back to you as soon as possible.
                    </p>
                `);
            },
            error: function (err) {
                console.error("❌ Error sending to webhook", err);
            },
            complete: function() {
                $submitBtn.prop('disabled', false).val('Submit contact');
            }
        });
    });

    // Product Inquiry to send data Zoho CRM
    $(document).on('submit', '#ContactForm-ask', function (e) {
        e.preventDefault(); 
        const form = $(this);
        const $submitBtn = form.find('button[type="submit"]');
        const originalBtnText = $submitBtn.text();
        const formData = new FormData(this);

        $submitBtn.prop('disabled', true).text('Sending...');

        $.ajax({
            url: 'https://ourportfolios.co/shopify-webhook/nextveda/product-inquiry.php',
            type: 'POST',
            data: formData,
            processData: false, 
            contentType: false, 
            dataType: 'json',
            success: function (res) {
                form[0].reset();
            },
            error: function (xhr) {
                console.error("Zoho Error Details:", xhr.responseText);
            },
            complete: function() {
                $submitBtn.prop('disabled', false).text(originalBtnText);
            }
        });
    });

    // Custom Cart Page API
    window.CustomCartAPI = {
        getSelectedVariantId: function () {
        if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
        return ShopifyAnalytics.meta.selectedVariantId;
        }

        const input = document.querySelector('input[name="id"]');
        if (input?.value) {
        return input.value;
        }

        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
    },

    addToCartDynamic: function (qty = 1) {
        const variantId = this.getSelectedVariantId();

        if (!variantId) {
        console.error('Variant ID not found');
        return;
        }

        return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(res => res.json())
        .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.top.location.href = '/cart';
        });
        }
    };

    // Product Gallery Main
    $('.productView-nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,     
        dots: false,
        infinite: true,
        fade: true,         
        speed: 0,          
        adaptiveHeight: true,
        asNavFor: '.productView-for',
    });

    // Product Gallery
    $('.productView-for').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        vertical: true,
        verticalSwiping: false,   
        focusOnSelect: true, 
        prevArrow: `
        <button type="button" class="slick-prev">
        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>
        </button>`,
        nextArrow: `
        <button type="button" class="slick-next">
        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>
        </button>`,
        asNavFor: '.productView-nav',
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                    verticalSwiping: false,
                }
            }
        ]
    });

    // Product Video
    $('.productView-nav').on('afterChange', function (event, slick, currentSlide) {
        $('.productView-video video').each(function () {
            this.pause();
            this.currentTime = 0;
        });

        var $currentSlide = $(slick.$slides[currentSlide]);
        var video = $currentSlide.find('video').get(0);

        if (video) {
            video.muted = false;   
            video.play().catch(function(err){
                console.log('Autoplay blocked:', err);
            });
        }
    });

});


// Product Accordion
document.addEventListener("DOMContentLoaded", function () {
    const triggers = document.querySelectorAll(".custom-accordion-title");

    triggers.forEach((btn) => {
        const content = btn.nextElementSibling;

        btn.addEventListener("click", () => {
            const isOpen = content.classList.contains("open");

            // Close all others
            document.querySelectorAll(".custom-accordion-content.open").forEach((openContent) => {
                if (openContent !== content) {
                    openContent.style.maxHeight = 0;
                    openContent.classList.remove("open");
                    openContent.previousElementSibling.classList.remove("active");
                }
            });
            if (isOpen) {
                content.style.maxHeight = 0;
                content.classList.remove("open");
                btn.classList.remove("active");
            } else {
                content.classList.add("open");

                // Allow browser to apply class BEFORE animating
                requestAnimationFrame(() => {
                    content.style.maxHeight = content.scrollHeight + "px";
                });

                btn.classList.add("active");
            }
        });
    });
});

// rich text custome
document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector(".rtc-content");
    const inner = document.querySelector(".rtc-content-inner");
    const btn = document.querySelector(".rtc-toggle-btn");
    if (!content || !inner || !btn) return;
    const WORD_LIMIT = 70;
    const fullHTML = inner.innerHTML.trim();
    const words = fullHTML.split(/\s+/);

    if (words.length <= WORD_LIMIT) {
        btn.style.display = "none";
        return;
    }

    const shortHTML = words.slice(0, WORD_LIMIT).join(" ") + "...";
    let isOpen = false;

    // ✅ Initial setup
    content.style.overflow = "hidden";
    content.style.transition = "max-height 0.35s ease";

    inner.innerHTML = shortHTML;
    content.style.maxHeight = content.scrollHeight + "px";

    const moreText = btn.dataset.more || "Read more";
    const lessText = btn.dataset.less || "Read less";

    btn.addEventListener("click", function () {
        const startHeight = content.scrollHeight;

        if (!isOpen) {
            inner.innerHTML = fullHTML;
            requestAnimationFrame(() => {
                content.style.maxHeight = inner.scrollHeight + "px";
            });
            btn.innerText = lessText;
        } else {
            inner.innerHTML = shortHTML;
            requestAnimationFrame(() => {
                content.style.maxHeight = inner.scrollHeight + "px";
            });
            btn.innerText = moreText;
        }

        isOpen = !isOpen;
    });

    // Hero video text section
    const videoBox = document.getElementById("videoBox");
    const thumb = document.getElementById("videoThumb");
    // Exit if required elements are missing
    if (!videoBox || !thumb) {
        console.warn("Video elements not found. Script skipped.");
        return;
    }
    const video = videoBox.querySelector("video");
    if (!video) {
        console.warn("No <video> tag inside #videoBox.");
        return;
    }
    video.style.display = "none";
    thumb.addEventListener("click", function () {
        thumb.style.display = "none";
        video.style.display = "block";
        video.play();
    });
});

// Custom BUy Now Button
document.addEventListener("DOMContentLoaded", function () {
  const buyNowBtn = document.querySelector(".custom-buy-now-btn");
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(() => {
        window.location.href = '/checkout';
      });
    });
  }
});


